import { createSlice } from "@reduxjs/toolkit";

const readCollapsed = () => {
  try {
    return localStorage.getItem("adminLegacySidebarCollapsed") === "1";
  } catch {
    return false;
  }
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    isOpen: false,
    collapsed: readCollapsed(),
  },
  reducers: {
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
    closeSidebar: (state) => {
      state.isOpen = false;
    },
    toggleSidebarCollapsed: (state) => {
      state.collapsed = !state.collapsed;
      try {
        localStorage.setItem(
          "adminLegacySidebarCollapsed",
          state.collapsed ? "1" : "0"
        );
      } catch {
        /* ignore */
      }
    },
  },
});

export const { toggleSidebar, closeSidebar, toggleSidebarCollapsed } =
  sidebarSlice.actions;
export default sidebarSlice.reducer;
